import styled, { css } from 'styled-components';

import { media } from './media-templates';

export const GlobalMarginContainer = styled.div<{ $isAuthenticated: boolean; $sidebarHidden: boolean }>(
  ({ $isAuthenticated, theme, $sidebarHidden }) => css`
    height: 100%;
    margin-top: ${$isAuthenticated ? '0' : '-60px'};
    background-image: ${$isAuthenticated
      ? 'none'
      : `radial-gradient(circle at 50% 50%, ${theme.white.a10}, ${theme.background})`};
    margin-left: ${$isAuthenticated && !$sidebarHidden ? '4rem' : '0'};
    ${media.phone`
      margin-left: 0;
    `}
  `,
);

export const SpinnerMargin = styled.div`
  margin-top: 30px;
`;

export const TileContainer = styled.section<{ $marginTop?: number }>(
  ({ theme, $marginTop = 15 }) => css`
    margin-top: ${$marginTop}px;
    background-color: ${theme.white.a10};
    box-shadow: ${theme.misc.tileShadow};
    border-radius: ${theme.misc.tileBRadius};
  `,
);

export const PageContentContainer = styled.div<{ $paddingBottom?: string }>`
  max-width: ${({ theme }) => theme.sz.pageContentWidth};
  width: 100%;
  margin: 0 auto;
  padding: 0 15px ${({ $paddingBottom }) => $paddingBottom};
`;

export const ListMargin = styled.div`
  padding-top: 225px;
`;

export const Web = styled.div`
  display: block;
  ${media.phone`
    display: none;
  `}
`;

export const Mobile = styled.div`
  display: none;
  ${media.phone`
    display: block;
  `}
`;

export const SmallTitle = styled.h6`
  font-size: 1rem;
  margin-bottom: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.baseBlue.a10};
`;

export const TextBox = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.baseBlue.a6};
  line-height: 26px;
`;
